module.exports = __webpack_public_path__ + "img/pool-icon-seigniorage.b719e104.svg";